import type { EnergyState, OutdoorCamera, RoomExtra, UpsState } from '../../types/beheer';

export const roomExtras: RoomExtra[] = [
  { roomId: 'werkkamer', humidity: 46, presenceSince: '38 min', scenes: ['Focus', 'Helder', 'Videobellen'], activeScene: 'Focus', satellite: { name: 'Satelliet werkkamer', status: 'online', lastHeard: '08:02' } },
  { roomId: 'woonkamer', humidity: 51, presenceSince: '9 uur', scenes: ['Ochtend', 'Samen', 'Film', 'Avond'], activeScene: null, satellite: { name: 'Satelliet woonkamer', status: 'online', lastHeard: '01:12' } },
  { roomId: 'keuken', humidity: 55, presenceSince: '2 min', scenes: ['Koken', 'Ontbijt'], activeScene: null, satellite: { name: 'Satelliet keuken', status: 'gedempt', lastHeard: 'gisteren' } },
  { roomId: 'slaapkamer', humidity: 58, presenceSince: '12 min', scenes: ['Opstaan', 'Lezen', 'Nacht'], activeScene: null, satellite: { name: 'Satelliet slaapkamer', status: 'online', lastHeard: '07:58' } },
  { roomId: 'badkamer', humidity: 72, presenceSince: '24 min', scenes: ['Douche', 'Nachtlicht'], activeScene: null, satellite: null },
  { roomId: 'gang', humidity: 49, presenceSince: '5 min', scenes: ['Thuiskomst', 'Nachtlicht'], activeScene: null, satellite: { name: 'Satelliet gang', status: 'offline', lastHeard: '07:31' } },
];

export const outdoorCameras: OutdoorCamera[] = [
  {
    id: 'cam-voordeur',
    name: 'Deurbel',
    location: 'Voordeur',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f6184a7f-30e0-4610-b3a3-11970899efba.jpg',
    maskHeight: 0.2,
    maskLabel: 'Straat en buren',
    retention: '7 dagen',
    recording: 'gebeurtenissen',
    lastEvent: 'Bezorger · 94%',
  },
  {
    id: 'cam-tuin',
    name: 'Achtertuin',
    location: 'Achtergevel',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d3d3e8f9-4459-49c5-b2e8-1fec6a0d1783.jpg',
    maskHeight: 0.44,
    maskLabel: 'Ramen en tuinen van buren',
    retention: '3 dagen',
    recording: 'gebeurtenissen',
    lastEvent: 'Kat · 02:18',
  },
  {
    id: 'cam-oprit',
    name: 'Oprit',
    location: 'Voorgevel, boven garage',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/672143fe-7202-4ad8-86cb-121e53561436.jpg',
    maskHeight: 0.36,
    maskLabel: 'Openbare stoep en straat',
    retention: '14 dagen',
    recording: 'continu',
    lastEvent: 'Geen sinds 22:40',
  },
];

export const energy: EnergyState = {
  solarNow: 0.42,
  useNow: 0.68,
  todayUse: 3.1,
  todaySolar: 0.6,
  todayCost: 0.74,
  hours: [
    { hour: 0, use: 0.21, solar: 0 },
    { hour: 1, use: 0.19, solar: 0 },
    { hour: 2, use: 0.24, solar: 0 },
    { hour: 3, use: 0.31, solar: 0 },
    { hour: 4, use: 0.38, solar: 0 },
    { hour: 5, use: 0.29, solar: 0 },
    { hour: 6, use: 0.44, solar: 0.02 },
    { hour: 7, use: 0.71, solar: 0.18 },
    { hour: 8, use: 0.33, solar: 0.4 },
  ],
};

export const ups: UpsState = {
  model: 'UPS 1500 VA · serverkast',
  onBattery: false,
  charge: 100,
  runtimeMin: 38,
  loadPct: 41,
  lastTest: '1 okt, geslaagd',
  protects: ['Anna-server', 'NAS', 'Router + switch', 'Zigbee/MQTT-hub'],
};
